/**
 * ConfirmationModal.js
 * Created by calhosh on 6/23/2021.
 */

import React from 'react';
import styled from 'styled-components';
import Modal from '../Modal/Modal';

function ConfirmationModal(props) {
	const {
		show,
		title,
		message,
		highlightedText,
		highlightedItems,
		confirmLabel,
		cancelLabel,
		tooltipClass,
		onConfirmClick,
		onHide,
		disableClose,
		isOkButtonDisabled,
		isCancelButtonDisabled,
		description,
		descriptionText,
		bodyText,
		bodyTextValue
	} = props;

	return (
		<StyledMotifModal
			show={show}
			title={title}
			modalsize="x-small"
			onHide={onHide}
			onOkClick={onConfirmClick}
			closeTitle={cancelLabel}
			closeBtnTitle={cancelLabel}
			confirmBtnTitle={confirmLabel}
			showButtons
			modalonmodal
			disableClose={disableClose}
			isOkButtonDisabled={isOkButtonDisabled}
			isCancelButtonDisabled={isCancelButtonDisabled}
			modalContainerClass="ConfirmModalContainer"
		>
			<section className="modalBodyWrapper customScrollbar">
				<section className="modalBodyDesc">{description}</section>
				{descriptionText && <section className="modalBodyDescText">{descriptionText}</section>}
				<section className="modalBodyTextWrapper">
					<section className="modalBodyText">{bodyText}&nbsp;</section>
					{bodyTextValue && <section className="modalBodyTextValue">{bodyTextValue}</section>}
				</section>
			</section>
		</StyledMotifModal>
	);
}

export default ConfirmationModal;

const StyledMotifModal = styled(Modal)``;
